const teams = [
  {
    id: 1,
    imageUrl: "/assets/img/avatars/avatar2.jpg",
    name: "Mr. Vikram ",
    // designation: "IT Expert",
  },
  {

    
    id: 2,
    imageUrl: "/assets/img/avatars/avatar1.jpg",
    name: "Ms . Aadhya",
    // designation: "Web Designer",
  },
  {
    id: 3,
    imageUrl: "/assets/img/avatars/avatar3.jpg",
    name: "Mr. Karthik",
    // designation: "Content Writer",
  },
  {
    id: 4,
    imageUrl: "/assets/img/avatars/avatar4.jpg",
    name: " Ms . Niharika",
    // designation: "Marketing officer",
  },
];
export {
    teams
}




